import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core'

/**
 * CKEditor Track changes component overridden styles
 */
export const useTrackedChangesPanelStyles = makeStyles(() => ({
    rightPanelClassBeta: {
        paddingTop: '20px',
        backgroundColor: '#EDF0F6',
    },
    trackChangesPanelBeta: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        minWidth: 240,
        width: '100%',
        position: 'relative',
    },
    actionsContainerBeta: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '0',
    },
    toggleContainerBeta: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    actionButtonGridBeta: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    toggleTitleBeta: {
        fontWeight: 600,
        color: '#185E8E',
        paddingLeft: 5,
        paddingTop: 5,
        fontSize: 14,
    },
    moreIconBeta: {
        fill: '#185E8E',
    },
    actionLabelBeta: {
        fontSize: pxToRem(13),
        color: '#185E8E',
    },
    closeButtonBeta: {
        paddingLeft: 5,
        color: '#185E8E',
        fontSize: 14,
    },
    editorContainerSidebar: {
        width: pxToRem(330),
        padding: '1.4rem',
        paddingRight: '0',
        position: 'relative',
        overflowY: 'auto',
        height: '-webkit-fill-available',
        // Hide scrollbar by default
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
            width: '0px', // Chrome/Safari
        },

        // When visible
        '&.scrolling': {
            scrollbarWidth: 'thin',
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#ccc',
                borderRadius: '4px',
            },
        },
    },
    sidebar: {
        paddingTop: '20px',
        backgroundColor: '#EDF0F6',
        transition:
            'width 0.1s cubic-bezier(0.4, 0, 1, 1), opacity 0.3s ease-in-out',
        opacity: 0,
        visibility: 'hidden',
        width: 0,
        display: 'none',
    },
    sidebarOpen: {
        width: '100%',
        opacity: 1,
        visibility: 'visible',
        display: 'block',
    },
    sidebarClosed: {
        width: 0,
        opacity: 0,
        visibility: 'hidden',
        display: 'none',
    },
    actionPopover: {
        fontSize: 14,
    },
}))
